import { combineReducers } from 'redux';
import loading from './loading.reducer';

const uxReducers = combineReducers({
  loading,
});

export default uxReducers;
